var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlPeople1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1136_5740",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1136_5740)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.32682 21.4H19.3605C19.8791 18.0464 17.9382 14.5258 14.8894 13.2874C14.628 13.1951 14.3436 13.1951 14.0823 13.2874C12.6417 13.8451 11.0492 13.8451 9.60869 13.2874C9.34735 13.1951 9.06295 13.1951 8.80161 13.2874C5.75033 14.5296 3.81188 18.0414 4.32682 21.4ZM11.8244 12.5727C12.7923 12.5737 13.7387 12.2837 14.5443 11.7395C15.35 11.1953 15.9787 10.4212 16.3513 9.51476C16.7238 8.60836 16.8233 7.61032 16.6374 6.64655C16.4516 5.68278 15.9885 4.79647 15.3068 4.09944C14.625 3.40241 13.755 2.92588 12.8066 2.72998C11.8582 2.53408 10.8739 2.62759 9.97781 2.9987C9.08173 3.36982 8.31405 4.00191 7.77163 4.81524C7.22921 5.62857 6.93634 6.58668 6.92998 7.56871C6.89284 10.3031 9.1024 12.5614 11.8244 12.5727Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.32682 21.4C3.81188 18.0415 5.75033 14.5296 8.80161 13.2862C9.06295 13.1939 9.34735 13.1939 9.60869 13.2862C11.0492 13.8439 12.6417 13.8439 14.0823 13.2862C14.3436 13.1939 14.628 13.1939 14.8894 13.2862C17.9382 14.5246 19.8791 18.0452 19.3605 21.3988L4.32682 21.4Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8246 12.5728C9.10133 12.5615 6.89301 10.3031 6.93015 7.57005C6.93334 6.58369 7.22477 5.62044 7.76757 4.80216C8.31036 3.98388 9.08016 3.34732 9.97955 2.97302C10.8789 2.59871 11.8675 2.50347 12.8202 2.69934C13.773 2.89522 14.6471 3.37341 15.332 4.07343C16.0168 4.77344 16.4817 5.66383 16.6678 6.63196C16.8538 7.60009 16.7527 8.60247 16.3773 9.5123C16.0018 10.4221 15.3689 11.1985 14.5585 11.7433C13.7481 12.2881 12.7967 12.5767 11.8246 12.5728Z",
    fill: "#333333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlPeople1);
export default __webpack_public_path__ + "static/media/bl_people1.c64bd0e3b649346b4b74c454311ca150.svg";
export { ForwardRef as ReactComponent };